import { render, staticRenderFns } from "./Webform.vue?vue&type=template&id=15fce3cc&"
import script from "./Webform.vue?vue&type=script&lang=js&"
export * from "./Webform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports